/* unplugin-vue-components disabled */import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=685461ee&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=685461ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685461ee"]])

export default __exports__